export default "__VITE_ASSET__6f253604__"